import { render } from "./ShipmentNotice.vue?vue&type=template&id=2b0f78e2&scoped=true"
import script from "./ShipmentNotice.vue?vue&type=script&lang=js"
export * from "./ShipmentNotice.vue?vue&type=script&lang=js"

import "./ShipmentNotice.vue?vue&type=style&index=0&id=2b0f78e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0f78e2"]])

export default __exports__